import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDataFlowFailedMessageResData } from "./GetDataFlowFailedMessageResData";

const ENDPOINT = "/dataflow/message/failed";

export class GetDataFlowFailedMessageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetDataFlowFailedMessageReqData = null;

    constructor(installationName: string, converterType: string) {
        super();
        this.params = new GetDataFlowFailedMessageReqData(installationName, converterType);
    }

    public async execute(): Promise<GetDataFlowFailedMessageResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetDataFlowFailedMessageResData(res);
    }
}

export class GetDataFlowFailedMessageReqData {
    installationName: string;
    converterType: string;

    constructor(installationName: string, converterType: string) {
        this.installationName = installationName;
        this.converterType = converterType;
    }
}
